import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import './App.css';


const theme = createMuiTheme({
  typography: {
      useNextVariants: true,
      fontFamily: '"Lato"',
  },
})



/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/
export default class App extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: '',
  };

  render() {
    return (
      <div className="home-app">
      <MuiThemeProvider theme={theme}>
            <div className="page-container">{this.props.children}</div>
        </MuiThemeProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/App.js